import React from "react";
import { Marker as MapGLMarker } from "react-map-gl";

import { Typography } from "@material-ui/core";

//@ts-ignore
import FiberManualRecordRoundedIcon from "@material-ui/icons/FiberManualRecordRounded";
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
//@ts-ignore
import StopRoundedIcon from "@material-ui/icons/StopRounded";

import SimpleTooltip, { SimpleTooltipBackgroundColour, SimpleTooltipPlacement } from "components/SimpleTooltip";
import useColourPalette from "components/visuals/useColourPalette";

import {
    ClassifiedCompetitor,
    CompetitorClassification
} from "modules/customer/tools/location/competitionNew/competitor";

interface MarkerProps {
    competitor: ClassifiedCompetitor,
    onTooltipOpen: () => void,
    onTooltipClose: () => void
}


const Marker: React.FC<MarkerProps> = (props) => {
    const { competitor, onTooltipOpen, onTooltipClose } = props;
    const colourPalette = useColourPalette();

    const getCompetitorIcon = (classification: CompetitorClassification) => {
        switch (classification) {
            case CompetitorClassification.Direct:
                return <PlayArrowRoundedIcon fontSize="small" cursor="pointer" style={{ color: colourPalette.categorical[2], transform: "rotate(90deg)" }} />;
            case CompetitorClassification.Standard:
                return <StopRoundedIcon fontSize="small" cursor="pointer" style={{ color: colourPalette.categorical[0], transform: "rotate(45deg)" }} />;
            case CompetitorClassification.Indirect:
                return <FiberManualRecordRoundedIcon fontSize="small" cursor="pointer" style={{ color: colourPalette.categorical[5] }} />;
            case CompetitorClassification.Alternate:
                return <StopRoundedIcon fontSize="small" cursor="pointer"  style={{ color: colourPalette.categorical[1] }} />;
            default:
                return <StopRoundedIcon fontSize="small" cursor="pointer" style={{ color: colourPalette.categorical[0], transform: "rotate(45deg)" }} />;
        }
    };

    return (
        <MapGLMarker
            latitude={competitor.latitude}
            longitude={competitor.longitude}
            offsetTop={-10}
            offsetLeft={-12}
        >
            <SimpleTooltip
                placement={SimpleTooltipPlacement.Bottom}
                backgroundColour={SimpleTooltipBackgroundColour.Quaternary}
                onOpen={onTooltipOpen}
                onClose={onTooltipClose}
                title={
                    <Typography variant="body2" component="div" align="center" style={{ fontWeight: "bold" }}>
                        {competitor.storeName}
                    </Typography>
                }
            >
                {getCompetitorIcon(competitor.classification)}
            </SimpleTooltip>
        </MapGLMarker>
    );
};

export default Marker;
